module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/companies/company-logo-15-6e354fd06ec4a934a576a44c80e7ba4a.png";